import {css} from '@logistics-frontend/blocks/theme/css'
import {spacing} from '@logistics-frontend/blocks/theme/theme'

export const slot = css`
  & + &:before {
    inset-inline: ${spacing(2)};
  }
`

export const distance = css`
  margin-inline-end: ${spacing(2)};
`
